module.exports = __webpack_public_path__ + "static/img/powertech.6fa8a4e.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/powertech.gif
// module id = 2lFJ
// module chunks = 0